import React from "react";

export default function () {
    return (
      <div className="footer py-4 d-flex flex-lg-column" id="kt_footer">
        {/*begin::Container*/}
        <div className="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between">
          {/*begin::Copyright*/}
          <div className="text-dark order-2 order-md-1">
            <span className="text-muted fw-bold me-1">EE</span>
          </div>
          {/*end::Copyright*/}
          {/*begin::Menu*/}
          {/*end::Menu*/}
        </div>
        {/*end::Container*/}
      </div>
    );
}